import type { UpdateContractStatusRequestPayload, UpdateContractStatusResponse } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUpdateContractStatus(contractId: string,
  options?: UseMutationOptions<UpdateContractStatusResponse, unknown, UpdateContractStatusRequestPayload>) {
  const queryClient = useQueryClient();

  return useMutation(['updateContractStatus'], (updateContractStatusRequest) => {
    const api = getPrivateApi();

    return api.updateContractStatus({ contractId, updateContractStatusRequest });
  },
  {
    onSuccess: () => queryClient.invalidateQueries(
      { 
        predicate: (query) => query.queryKey.includes(contractId) || query.queryKey.includes('contracts'), 
      }), ...options, 
  });
}